export const FETCH_ROLES = '@admission/FETCH_ROLES';
